export default {
  logging_out: 'Logging out',
  logging_out_failed: 'Logout failed',
  logging_out_success: 'Successfully logged out.',
  logging_in_success: 'Successfully logged in.',
  user_has_been_deactivated:
  'your account has been deactivated, please contact our system administrator to reactivate your account',
};
